const AuthHeader = () => {
  return (
    <div className="flex items-center justify-center mb-4 gap-3">
      <img
        src="/images/Auth-Pages/logo.svg"
        alt="Opsero Logo"
        className="w-10 h-10 object-contain"
      />
      <h1 className="text-[24px] font-['Tilt_Warp'] text-[#350666]">
        OPSERO
      </h1>
    </div>
  );
};

export default AuthHeader;